import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { MyUserDataResponse } from 'src/shared/features/users/schemas/user'

export const getCurrentUserFromDB = () => getRequest<MyUserDataResponse>('/users/me')

interface UseMyUserDataConfig {
  enabled?: boolean
}

export const useMyUserData = ({ enabled = true }: UseMyUserDataConfig = {}) => {
  return useQuery({
    ...queries.users.me,
    queryFn: async () => {
      const response = await getCurrentUserFromDB()
      if (!response || !response.user) {
        throw new Error('User data is undefined')
      }
      return response.user
    },
    retry: 1,
    staleTime: 30 * 60 * 1000, // 30 minutes
    enabled,
  })
}

export const useMyUserTokens = () => {
  return useQuery({
    ...queries.users.me._ctx.tokens,
    queryFn: async () => {
      const response = await getCurrentUserFromDB()
      if (!response || !response.tokens) {
        throw new Error('User tokens are undefined')
      }
      return response.tokens
    },
    retry: 1,
    staleTime: 15 * 60 * 1000,
  })
}
